import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, FieldArray } from "formik";
import "./ParticipantForm.scss";
import {
  PARTICIPANT_DATA_COLLECTED,
  PARTICIPANTS_RESET,
  PATH_PARTICIPANTS_RESET
} from "../constants";
import Name from "./Name";
import BirthDate from "./BirthDate";
import ParticipantList from "./ParticipantList";
import { validateName, guardianAgeTest } from "./validation";
import { currentLocale } from "../locale";
import DropDown from "./dropDown";
import "./ParticipantForm.scss";
import LinkedParticipantList from "./LinkedParticipantList";
import { getLinkedParticipants } from "../action-creators/signedWaiver";

class BothDrop extends Component {
  constructor(props) {
    super(props);
    this.handleSingleLinkedParticipant = this.handleSingleLinkedParticipant.bind(
      this
    );
    this.state = {
      stateParticipantData: {
        name: "",
        referenceKey: "",
        birthday: "", //client optional
        participants: [
          {
            participantName: "",
            participantBirthday: "",
            referenceKey: ""
          }
        ],
        role: 0 //isParticipant - already entered (its own tab)
      },
      participants: [], //this.props.participants,
      linkedParticipants: [], //this.props.linkedParticipants,
      selected: []
    };
  }

  handleSingleLinkedParticipant = event => {
    this.props.formikProps.setFieldTouched(`name`, true, true);

    if (!isNaN(event)) {
      this.props.formikProps.setFieldValue(`id`, event);
      this.props.getLinkedParticipants(event);
    } else {
      this.props.formikProps.setFieldValue(
        `linkedParticipant[0].participantName`,
        event.target.value
      );
    }
  };

  componentWillMount() {
    /* checks if stepped backwards and if so it resets participants info*/
    if (this.props.skippedBackwards) {
      this.props.setInvalid();
      this.props.participantsReset();
      this.props.getPathParticipants();
    }
  }

  render() {
    const { linkedPath, values, signingInfo, waiver } = this.props;

    return (
      <div className="collect-participant-information">
        {Number(signingInfo.role) === 1 ? (
          <div>
            {linkedPath ? (
              <div>
                <Field
                  name="name"
                  validate={validateName}
                  component={DropDown}
                  onChange={this.handleSingleLinkedParticipant}
                  placeholder={currentLocale.fullNamePlaceHolder}
                  label={currentLocale.yourGuardian}
                />
              </div>
            ) : (
              <Field
                name="name"
                validate={validateName}
                component={Name}
                placeholder={currentLocale.namePlaceHolder}
                label={currentLocale.yourName}
              />
            )}

            {waiver.birthday ? (
              <Field
                name="birthday"
                validate={guardianAgeTest}
                component={BirthDate}
                placeholder={currentLocale.datePlaceholder}
                label={currentLocale.yourBirthday}
              />
            ) : null}
          </div>
        ) : Number(signingInfo.role) === 2 ? (
          <div>
            {linkedPath ? (
              <Field
                name="signedByName"
                validate={validateName}
                component={Name}
                placeholder={currentLocale.fullNamePlaceHolder}
                label={currentLocale.yourGuardian}
              />
            ) : (
              <Field
                className="input"
                validate={validateName}
                name="name"
                component={Name}
                placeholder={currentLocale.namePlaceHolder}
                label={currentLocale.yourName}
              />
            )}

            {linkedPath ? (
              <FieldArray
                className="input"
                name="linkedParticipants"
                validate={validateName}
                locationData={this.props.locationData}
                pathParticipants={this.props.pathParticipants}
                linkedParticipant={this.props.linkedParticipant}
                linkedParticipants={this.props.linkedParticipants}
                component={LinkedParticipantList}
              />
            ) : (
              <FieldArray
                className="input"
                name="participants"
                locationData={this.props.locationData}
                pathParticipants={this.props.pathParticipants}
                value={values.participants}
                component={ParticipantList}
              />
            )}
          </div>
        ) : Number(signingInfo.role) === 3 ? (
          <div>
            <div>
              {linkedPath ? (
                <Field
                  className="input"
                  name="name"
                  validate={validateName}
                  component={DropDown}
                  onChange={this.handleSingleLinkedParticipant}
                  label={currentLocale.yourGuardian}
                  placeholder={currentLocale.fullNamePlaceHolder}
                  locationData={this.props.locationData}
                />
              ) : (
                <Field
                  className="input"
                  validate={validateName}
                  name="name"
                  component={Name}
                  label={currentLocale.yourName}
                  placeholder={currentLocale.namePlaceHolder}
                />
              )}
              {waiver.birthday ? (
                <Field
                  className="input"
                  validate={guardianAgeTest}
                  name="birthday"
                  type="birthday"
                  component={BirthDate}
                  placeholder={currentLocale.datePlaceholder}
                  label={currentLocale.yourBirthday}
                />
              ) : null}
              {linkedPath ? (
                <FieldArray
                  className="input"
                  name="linkedParticipants"
                  validate={validateName}
                  locationData={this.props.locationData}
                  pathParticipants={this.props.pathParticipants}
                  linkedParticipant={this.props.linkedParticipant}
                  linkedParticipants={this.props.linkedParticipants}
                  value={values.linkedParticipants}
                  component={LinkedParticipantList}
                />
              ) : (
                <FieldArray
                  className="input"
                  name="participants"
                  value={values.participants}
                  component={ParticipantList}
                />
              )}
            </div>
          </div>
        ) : (
          <div>{currentLocale.roleError}</div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  signingInfo: state.signingInfo,
  birthday: state.signingInfo.birthday,
  name: state.signingInfo.name,
  participants: state.signingInfo.participants,
  locationData: state.locationData,
  pathParticipants: state.pathParticipants.participants,
  linkedParticipant: state.pathParticipants.linkedParticipant,
  linkedParticipants: state.pathParticipants.linkedParticipants,
  stepper: state.stepper,
  skippedBackwards: state.stepper.skippedBackwards
});

const mapActionsToProps = dispatch => ({
  valueToAppState: value => {
    dispatch({ type: PARTICIPANT_DATA_COLLECTED, payload: value });
  },
  getLinkedParticipants: value => dispatch(getLinkedParticipants(value)),
  participantsReset: () => {
    dispatch({ type: PARTICIPANTS_RESET });
    dispatch({ type: PATH_PARTICIPANTS_RESET });
  }
});

const connector = connect(
  mapStateToProps,
  mapActionsToProps
);

export default connector(BothDrop);
